import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

import { updateMeasurementUnit } from "../../../../../services/Admin/MaterialsApi";

const EditeUnitsdialog = ({ open, onClose, unit = null, onUpdated }) => {
  const [name, setName] = useState("");
  const [abbreviation, setAbbreviation] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (open) {
      setError("");
      setSuccess("");
      setName(unit?.name || "");
      setAbbreviation(unit?.abbreviation || "");
    }
  }, [open, unit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!unit || !unit.id) {
      setError("لا يوجد معرف للوحدة");
      return;
    }
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      const res = await updateMeasurementUnit({
        id: unit.id,
        name,
        name_en: "",
        abbreviation,
      });

      setSuccess(res?.message || "تم التحديث بنجاح");
      if (typeof onUpdated === "function") onUpdated(res?.data || null);
      if (typeof onClose === "function") onClose();
    } catch (err) {
      setError(err?.message || "فشل في تحديث وحدة القياس");
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setError("");
    setSuccess("");
    if (typeof onClose === "function") onClose();
  };

  return (
    <Dialog open={Boolean(open)} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>تعديل وحدة قياس</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2, mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}

          <TextField label="الاسم" value={name} onChange={(e) => setName(e.target.value)} fullWidth required />
          <TextField label="الاختصار" value={abbreviation} onChange={(e) => setAbbreviation(e.target.value)} fullWidth />

          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button onClick={handleClose} color="inherit">إلغاء</Button>
            <Button type="submit" variant="contained" disabled={saving}>
              {saving ? <CircularProgress size={20} /> : "حفظ"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default EditeUnitsdialog;
